/** Vite serves /api through its configured proxy. SWA keeps its deployment URL. */
export function applicationApiPath(path:string,backend:string,development:boolean=import.meta.env.DEV,browser=typeof window!=='undefined'):string {
 return development&&browser&&path.startsWith('/api/')?path:backend+path;
}
